import { render, staticRenderFns } from "./ObservationsTable.vue?vue&type=template&id=2cd8b72a"
import script from "./ObservationsTable.vue?vue&type=script&lang=js"
export * from "./ObservationsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports